// Admin-owned ACE artwork and contact details. Session media stays in app.js/API.
export function applyAceDesign(site, landing) {
  document.body.dataset.siteDesign = 'ace-archery-2010';
  document.title = 'ACE Archery · 20/10 — Khoảnh khắc của bạn';
  document.querySelector('meta[name="theme-color"]').content = '#173d31';
  document.querySelector('link[rel="icon"]').href = '/ace/logo.png';
  const brand = document.querySelector('.brand');
  brand.href = `/${site.slug}`;
  brand.setAttribute('aria-label', 'ACE Archery — trang chủ');
  brand.querySelector('img').src = '/ace/logo.png';
  brand.querySelector('img').hidden = false;
  brand.querySelector('span').textContent = 'ACE ARCHERY';
  document.querySelectorAll('.state-panel .eyebrow').forEach(el => { el.textContent = 'ACE ARCHERY · 20/10'; });
  if (!document.querySelector('.ace-header-contact')) {
    document.querySelector('.header-note').hidden = true;
    const contacts = document.createElement('nav');
    contacts.className = 'ace-header-contact';
    contacts.setAttribute('aria-label', 'Liên hệ ACE');
    contacts.innerHTML = '<a href="tel:0942606345">0942606345</a><a class="ace-contact-link" href="https://www.facebook.com/profile.php?id=61561039346146" target="_blank" rel="noopener noreferrer">Liên hệ ACE</a><span class="ace-date">20/10</span>';
    document.querySelector('.site-header').append(contacts);
    const gallery = document.getElementById('gallery');
    const intro = document.querySelector('.hero-copy');
    intro.classList.add('ace-intro');
    intro.querySelector('.eyebrow').textContent = 'ACE ARCHERY · 20/10';
    intro.querySelector('h1').textContent = 'Khoảnh khắc của bạn';
    intro.querySelector('.intro').textContent = 'Lưu giữ một ngày thật đẹp.';
    gallery.prepend(intro);
    document.getElementById('download-main').textContent = 'Tải tất cả ảnh';
    const meta = document.createElement('div');
    meta.className = 'ace-featured-meta';
    meta.innerHTML = '<span>Ảnh 01</span><a id="ace-download-featured" href="#">Tải ảnh ↓</a>';
    document.querySelector('.hero').append(meta);
    document.getElementById('main-photo').alt = 'Ảnh nổi bật trong lượt chụp của bạn tại ACE Archery';
    intro.append(document.getElementById('photo-count'));
    const contact = document.createElement('section');
    contact.id = 'ace-contact';
    contact.setAttribute('aria-labelledby', 'ace-contact-title');
    contact.innerHTML = '<h2 id="ace-contact-title">Hẹn bạn tại ACE Archery</h2><p class="ace-blossom" aria-hidden="true">― ✿ ―</p><div class="ace-contact-card"><div><strong>Địa chỉ</strong><p>33–35 Đường 30 Tháng Tư, Đà Nẵng</p></div><div><strong>Liên hệ</strong><p><a href="tel:0942606345">0942606345</a></p></div><a class="button button-dark" href="https://www.facebook.com/profile.php?id=61561039346146" target="_blank" rel="noopener noreferrer">Liên hệ ACE →</a></div>';
    document.querySelector('footer').before(contact);
    document.querySelector('footer').innerHTML = '<div class="ace-footer-brand"><img src="/ace/logo.png" alt="" width="56" height="56"><div><strong>ACE ARCHERY · CLB BẮN CUNG ĐÀ NẴNG</strong><p>Chúc mừng ngày Phụ nữ Việt Nam 20/10</p><a href="tel:0942606345">0942606345</a></div></div><p class="ace-footer-wish">Mạnh mẽ · Tự tin · Rạng rỡ</p>';
  }
  if (landing) {
    let panel = document.getElementById('site-landing');
    if (!panel) {
      panel = document.createElement('section');
      panel.id = 'site-landing';
      panel.className = 'site-landing ace-intro';
      panel.innerHTML = '<p class="eyebrow">ACE ARCHERY · 20/10</p><h1>Khoảnh khắc của bạn</h1><p class="intro">Lưu giữ một ngày thật đẹp.</p><div class="site-qr-note"><h2>Mở bộ ảnh của bạn</h2><p>Quét mã QR nhận được sau khi chụp để xem và tải ảnh của bạn.</p></div>';
      document.querySelector('main').append(panel);
    }
    panel.hidden = false;
  }
}
